<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex items-center gap-3 min-w-0 flex-1">
            <ReflectionIcon kind="team" size="md" />
            <div class="flex flex-col gap-1 min-w-0">
                <div class="flex items-center gap-2.5 flex-wrap">
                    <span class="body-semibold text-ink">{{ t("reflections.team.giveFeedbackTo", { name: request.subject_first_name }) }}</span>
                    <FeatureChip feature="team-reflect">{{ t("reflections.team.request.chip") }}</FeatureChip>
                </div>
                <div class="scaffold-body-small text-ink-muted">{{ t("reflections.team.request.requestedBy", { name: request.subject_first_name }) }}</div>
            </div>
        </div>
        <a
            :href="`/reflections/360/r/${request.invite_token}/`"
            class="base-btn-neutral base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            :aria-label="t('reflections.team.request.giveFeedbackAria', { action: t('reflections.team.request.giveFeedback'), name: request.subject_first_name })"
            @click.prevent="emit('give-feedback', request)">
            {{ t("reflections.team.request.giveFeedback") }}
        </a>
    </BaseCard>
</template>

<script setup lang="ts">
import type { TeamReflectionRequest } from "~vue/api/generated/reflections";
import BaseCard from "~vue/components/BaseCard.vue";
import FeatureChip from "~vue/components/FeatureChip.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface Props {
    request: TeamReflectionRequest;
}

defineProps<Props>();
const emit = defineEmits<{ (event: "give-feedback", request: TeamReflectionRequest): void }>();
</script>
